/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable consistent-return */
/* eslint-disable max-len */
/* eslint-disable react/prop-types */
import React, { useEffect, useRef, memo } from 'react';
import PropTypes from 'prop-types';
import {
  ContentContainer,
  Image,
  Header,
  Message,
  ToastContainer
} from './Toast.style';
import { close, errorToast, successToast } from '../../../assets/icons';
import DynamicSVGIcon from '../DynamicSVGIcon';

const Toast = ({
  message,
  header,
  fn = () => {},
  style = { bottom: 30 },
  shouldFade = true,
  className,
  doNotAutoClose = false
}) => {
  const toastRef = useRef();

  useEffect(() => {
    if (!doNotAutoClose) {
      if (shouldFade) {
        toastRef.current.onanimationend = () => {
          fn();
        };
      }
      return () => {
        if (message && shouldFade) {
          fn();
        }
      };
    }
  }, []);

  return (
    <ToastContainer
      style={style}
      ref={toastRef}
      className={`${className} ${shouldFade ? 'fade' : 'show'}`}
    >
      {doNotAutoClose && (
        <div
          style={{ position: 'absolute', right: '12px' }}
          onClick={() => {
            fn();
          }}
        >
          <DynamicSVGIcon iconUrl={close} />
        </div>
      )}
      {header === 'Error' ? (
        <Image src={errorToast} alt='error' />
      ) : (
        header === 'Success' && <Image src={successToast} alt='success' />
      )}
      <ContentContainer>
        <Header>{header}</Header>
        <Message>{message}</Message>
      </ContentContainer>
    </ToastContainer>
  );
};

Toast.propTypes = {
  message: PropTypes.string.isRequired,
  header: PropTypes.string.isRequired,
  fn: PropTypes.func.isRequired
};

export default memo(Toast);
